import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function InfoAltMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M12 22C6.477 22 2 17.521 2 12 2 6.475 6.477 2 12 2s10 4.476 10 10c0 5.522-4.477 10-10 10zm0-2a8 8 0 100-16.001 8 8 0 000 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z"  /></Svg>;
}
export default InfoAltMedium;